"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("../icon-base"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FaLaptop = function FaLaptop(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M416 1280q-66 0-113-47t-47-113V416q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47H416zm-32-864v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5V416q0-13-9.5-22.5T1504 384H416q-13 0-22.5 9.5T384 416zm1376 928h160v96q0 40-47 68t-113 28H160q-66 0-113-28t-47-68v-96h1760zm-720 96q16 0 16-16t-16-16H880q-16 0-16 16t16 16h160z"
  })));
};
FaLaptop.defaultProps = {
  viewBox: '0 0 1920 1896.083',
  height: '1em',
  width: '1.0126em'
};
FaLaptop.displayName = 'FaLaptop';
var _default = FaLaptop;
exports.default = _default;